module.exports = __webpack_public_path__ + "static/media/sun.186b3e4e.svg";